import { useState, useEffect } from 'react';

interface ClientOnlyProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  condition?: () => boolean;
}

export default function ClientOnly({ children, fallback = null, condition }: ClientOnlyProps) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  // If we have a condition, check it
  if (condition && !condition()) {
    return <>{fallback}</>;
  }

  // If not client-side yet, show fallback
  if (!isClient) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
} 